import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { IProviderProps, ISingleSelectContext, ISingleSelectItem } from "../@types/ContextProviderRelated";
import { IconHand, IconMove } from "../assets/icons";

const singleSelectDefaultValues: ISingleSelectContext = {
    currentlySelected: {
        id: 0,
        icon: IconHand,
        text: ""
    },
    setCurrentlySelected: () => {},
    items: [],
    setItems: () => {}
};

export const SingleSelectContext = createContext(singleSelectDefaultValues);

export const useSingleSelectContext = () => useContext(SingleSelectContext);

export const SingleSelectProvider = ({ children }: IProviderProps): JSX.Element => {
    const intl = useIntl();

    const generateItems = useCallback((): ISingleSelectItem[] => [
        {
            icon: IconHand,
            text: intl.formatMessage({ id: "Toolbar.select" }),
            id: 0
        },
        {
            icon: IconMove,
            text: intl.formatMessage({ id: "Toolbar.move" }),
            id: 1
        },
    ], [intl]);

    const [items, setItems] = useState<ISingleSelectItem[]>(generateItems);
    const [selectedItem, setSelectedItem] = useState<ISingleSelectItem>(generateItems()[0]);

    useEffect(() => {
        const newItems = generateItems();
        setItems(newItems);
        setSelectedItem(newItems.find((item) => item.id === selectedItem.id) || newItems[0]);
    }, [intl, generateItems, selectedItem.id]);
    

    const setCurrentlySelected = (item: ISingleSelectItem): void => {
        if (selectedItem.id !== item.id) {
            setSelectedItem(item);
        }
    };

    return (
        <SingleSelectContext.Provider value={{
            currentlySelected: selectedItem,
            setCurrentlySelected,
            items,
            setItems
        }}>
            {children}
        </SingleSelectContext.Provider>
    );
};

export default SingleSelectProvider;
